import React, { Component } from 'react';

import CustomerList from './Delivery/CustomerList';

class MonitoningDeliveries extends Component {

    /* constructor(props) {
        super(props);
    } */

    render() {
        const deliveries = this.props.deliveries;

        return (
            <div className="md-deliveries">
                <h3>Entregas</h3>

                <CustomerList data={deliveries} />
            </div>
        );
    }

}

export default MonitoningDeliveries;



// WEBPACK FOOTER //
// ./src/components/MonitoningDeliveries.js